import { Collapse } from '@mui/material';
import styled from '@emotion/styled';
import { useState } from 'react';
import { MdExpandMore } from 'react-icons/md';

const AdvancedOptions = styled.div`
  margin-top: 16px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  text-align: left;
  padding: 0;
  min-height: unset;
  cursor: pointer,
  user-select: 'none',
`;

const StyledExpandMore = styled(MdExpandMore, {
  shouldForwardProp: (prop) => prop !== 'show',
})`
  margin-left: 8px;
  transition: transform 0.2s;
  transform: ${({ show }) => (show ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

function View({
  children, open, handleOpen, handleOnKeyDown,
}) {
  return (
    <>
      <AdvancedOptions
        role="button"
        tabIndex={0}
        onClick={handleOpen}
        onKeyDown={handleOnKeyDown}
        aria-expanded={open}
        aria-controls="advanced-options-collapse"
      >
        <span>Advanced Options</span>
        <StyledExpandMore
          size={18}
          aria-hidden="true"
          focusable="false"
          show={open}
        />
      </AdvancedOptions>
      <Collapse in={open} id="advanced-options-collapse">
        {children}
      </Collapse>
    </>
  );
}

function Model({ children }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen((v) => !v);
  };

  const handleOnKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleOpen();
    }
  };

  const hookProps = {
    children,
    open,
    handleOpen,
    handleOnKeyDown,
  };

  return (
    <View
      {...hookProps}
    />
  );
}

export default Model;
export { View };
